(function () {
  //header search
  const searchButton = document.querySelector(".site-header__search .search-submit");
  const searchField = document.querySelector(".site-header__search .search-field");
  if (searchButton && searchField) {
    let hasFocus = false;
    searchButton.addEventListener("click", (e) => {
      if (!hasFocus) {
        e.preventDefault();
        searchField.focus();
        hasFocus = true;
      }
    });
    searchField.addEventListener("blur", (e) => {
      if (e.relatedTarget !== searchButton) hasFocus = false;
    });
  }

  document.querySelectorAll(".scroll-to").forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute("href")).scrollIntoView({
        behavior: "smooth",
      });
    });
  });

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    var header = document.querySelector("header");
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      if (!header.classList.contains("site-header--scrolled")) header.classList.add("site-header--scrolled");
    } else {
      if (header.classList.contains("site-header--scrolled")) header.classList.remove("site-header--scrolled");
    }
  }

  if (document.querySelector(".wp-block-gallery")) {
    window.Fancybox.bind(".wp-block-gallery .wp-block-image a", {
      groupAll: true,
      Carousel: {
        formatCaption: (_carouselRef, slide) => {
          return slide.triggerEl?.nextElementSibling || "";
        },
      },
    });
  }
})();
